<template>
    <div class="modal fade" id="appMgrAccessAuthorityViewerModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="width: 960px;">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            アクセス権限の許可設定
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div style="margin-bottom: 16px;">
                        アプリケーションが要求するアクセス権限の許可について、以下の設定が行われています。
                    </div>
                    <div class="d-flex flex-row align-items-center" style="margin-bottom: 16px;">
                        既定の設定：
                        <input type="text" class="input-text-scv" v-bind:value="converter.GetPermissionSettingText(defaultPermission)" style="width: 320px" disabled />
                    </div>
                    <ListCtrl ref="listCtrl"
                              :columns="columns"
                              :selectType="0"
                              :getCellTextFunc="getCellText"
                              style="min-height: 240px;">
                    </ListCtrl>
                    <div style="height: 8px;"></div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal">閉じる</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import $ from "jquery";
    import { ListCtrl } from 'lib-vue-v2/components';
    import { ApplicationPolicyDef, ApplicationPolicyConverter } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter'
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'

    @Options({
        props: {
            list: { type: Array, required: true },  // 権限一覧（Array<schema.AMAPI_ApplicationPermission>）
            listSetting: { type: Array, required: true },  // 設定一覧（Array<schema.AMAPI_PermissionGrant>）
            defaultPermission: { type: String, required: true }, // 既定の権限設定(ApplicationPolicyDef.PERMISSION_GRANT_TYPE)
        },
        components: {
            ListCtrl,
        },
    })

    export default class AppMgrAccessAuthorityViewerModal extends Vue {
        // 発行済みID
        private static modalIDNumber = 0;
        // 自身のID
        private myModalIDNumber = 0;

        // リスト関連
        private readonly columns: Array<SearchColumnData> =
            [
                { columnID: 0, dataType: SearchColumnType.string, text: "アクセス権限" },
                { columnID: 1, dataType: SearchColumnType.string, text: "許可設定" },
            ];

        // props
        private list!: Array<schema.AMAPI_ApplicationPermission>;        // 権限情報一覧
        private listSetting!: Array<schema.AMAPI_PermissionGrant>;       // 設定一覧
        private defaultPermission!: ApplicationPolicyDef.PERMISSION_GRANT_TYPE; // 既定の権限設定

        // メンバ変数
        private mapSetting = new Map<string, ApplicationPolicyDef.PERMISSION_GRANT_TYPE>();  // listSettingへアクセスしやすいようにMap化

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        /**
         * @brief   created
         */
        public created(): void {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            AppMgrAccessAuthorityViewerModal.modalIDNumber += 1;
            this.myModalIDNumber = AppMgrAccessAuthorityViewerModal.modalIDNumber;
        }

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrAccessAuthorityViewerModal').attr('id', "appMgrAccessAuthorityViewerModal" + this.myModalIDNumber);

            const el = document.getElementById("appMgrAccessAuthorityViewerModal" + this.myModalIDNumber);
            if(null != el) {
                // 画面が開いた時の処理
                el.addEventListener('show.bs.modal', () => {
                    this.listSetting.forEach(x => {
                        if (null == x.permission || undefined == x.permission) {
                            return;
                        }
                        this.mapSetting.set(x.permission, this.converter.ConvertStringToPermissionType(x.policy));
                    });

                    // リスト作成
                    const refObj: any = this.$refs;
                    refObj.listCtrl.updateList(this.list.length);
                });

                // 画面が閉じるときの処理
                el.addEventListener('hide.bs.modal', () => {
                    this.mapSetting = new Map<string, ApplicationPolicyDef.PERMISSION_GRANT_TYPE>();
                    const refObj: any = this.$refs;
                    refObj.listCtrl.updateList(0);                    
                });
            }    
        }

        /**
         * リスト作成処理
         */
        private getCellText(columnId: number, index: number): string {

            if (this.list.length <= index) {
                return "";
            }

            switch (columnId) {
                // アクセス権限
                case 0:
                    return this.converter.GetPermissionNameText(this.list[index]);

                // 許可設定
                case 1:
                    {
                        const key = this.list[index].permissionId;
                        if (null == key || undefined == key) {
                            return "既定の設定";
                        }
                        const find = this.mapSetting.get(key);
                        if (undefined !== find) {
                            return "個別設定（" + this.converter.GetPermissionSettingText(find) + "）";
                        }
                        else {
                            // 有効な設定にないので既定
                            return "既定の設定";
                        }
                    }
            }
            return "";
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return 'appMgrAccessAuthorityViewerModal' + this.myModalIDNumber;
        }
    }
</script>

<style scoped>
</style>
